<template>
    <section class="rtb-form-section" data-field="creative_ids">
        <fieldset class="rtb-form-fieldset">
            <legend>Креативы</legend>
            <p class="field__hint">
                Снятие галочки ставит креатив на паузу в ротации, без удаления привязки.
            </p>
            <p v-if="errors.creative_ids" class="field__error">{{ errors.creative_ids }}</p>
            <p v-if="!creatives.length" class="field__hint">Нет доступных RTB-креативов. Сначала создайте и подтвердите креативы.</p>
            <div v-else class="rtb-creatives">
                <div
                    v-for="creative in creatives"
                    :key="creative.id"
                    :class="['rtb-creatives__item', { 'is-selected': isSelected(creative.id), 'is-paused': isPaused(creative) }]"
                >
                    <label class="rtb-creatives__main">
                        <input v-model="selectedIds" type="checkbox" :value="creative.id" :disabled="disabled" />
                        <span>
                            <strong>{{ creative.name }}</strong>
                            <span v-if="isPaused(creative)" class="rtb-creatives__badge">На паузе</span>
                            <span v-if="showReadinessHint" class="rtb-creatives__hint">Выберите экраны для проверки готовности</span>
                            <span
                                v-else-if="!isReady(creative)"
                                class="rtb-creatives__badge is-warn"
                                :title="readinessTooltip(creative)"
                            >Не готов к показам</span>
                            <span class="rtb-creatives__meta">
                                ID {{ creative.id }}
                                <template v-if="creative.size"> · {{ creative.size }}</template>
                            </span>
                        </span>
                        <img v-if="creative.url && creative.type === 'picture'" :src="creative.url" class="rtb-creatives__thumb" alt="" />
                    </label>
                    <label v-if="showMaxBid && isSelected(creative.id)" class="rtb-creatives__bid">
                        Max Bid, ₸
                        <input
                            type="number"
                            min="0"
                            step="0.01"
                            class="form-input"
                            :value="bids[creative.id] ?? ''"
                            :disabled="disabled"
                            @input="emit('set-bid', creative.id, $event.target.value)"
                        />
                    </label>
                </div>
            </div>
        </fieldset>
    </section>
</template>

<script setup>
defineProps({
    creatives: { type: Array, default: () => [] },
    errors: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    showMaxBid: { type: Boolean, default: false },
    bids: { type: Object, default: () => ({}) },
    showReadinessHint: { type: Boolean, default: false },
    isSelected: { type: Function, required: true },
    isPaused: { type: Function, required: true },
    isReady: { type: Function, required: true },
    readinessTooltip: { type: Function, required: true },
});

const emit = defineEmits(['set-bid']);
const selectedIds = defineModel({ type: Array, required: true });
</script>
